<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="640"
  >
    <v-card>
      <div :class="$style.host">
        <distributor-form-email v-if="showEmailForm" v-bind:inCompanyExistsModal="true" @close="close"/>

        <template v-else>
          <div :class="$style.headline">
            <span>Distributor already exists!</span>
          </div>
          <div :class="$style.description">
            <span>
              Would you like to continue registering with an existing distributor?
            </span>
          </div>

          <v-btn
              color="#203e52"
              type="submit"
              :class="$style.button"
              @click="onConfirm"
          >
            Yes
          </v-btn>
        </template>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import DistributorFormEmail from '@/features/registration/components/distributor-form-email';
import {
  SET_DISTRIBUTOR_ERROR,
  SET_REGISTRATION_STEP,
  START_LOADING,
  STOP_LOADING,
  VERIFY_EMAIL,
} from '@/features/registration/store/modules/registration';
import {mapActions, mapMutations, mapState} from "vuex";
import {ServerValidationError} from "@/axios/exceptions";

export default {
  name: 'CompanyExist',
  components: {
    DistributorFormEmail
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showEmailForm: false
    }
  },
  computed: {
    ...mapState([
        'userEmail'
    ]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value.state);
        if (!value.state) {
          this.$emit('close', value.answer);
        }
      },
    },
  },
  methods: {
    ...mapMutations({
      setRegistrationStep: SET_REGISTRATION_STEP,
      setDistributorError: SET_DISTRIBUTOR_ERROR,
      startLoading: START_LOADING,
      stopLoading: STOP_LOADING,
    }),
    ...mapActions({
      verifyEmail: VERIFY_EMAIL,
    }),
    close(answer) {
      this.show = {
        state: false,
        answer
      };
    },
    async onConfirm() {
      this.startLoading();

      try {
        await this.verifyEmail(this.userEmail);
        this.setRegistrationStep();
        this.$emit('close', true);
      } catch (error) {
        this.showEmailForm = true;

        if (error instanceof ServerValidationError) {
          this.setDistributorError(error.message);
        }
      } finally {
        this.stopLoading();
      }
    }
  },
};
</script>

<style lang="scss" module>
.host {
  padding: 60px 9%;
  text-align: center;

  .icon {
    width: 100%;
    max-width: 80px;
  }

  .headline {
    margin-top: 25px;

    > span {
      @include font-rubik-grey(32px, 500, 38px);
    }
  }

  .description {
    margin-top: 15px;

    > span {
      @include font-open-sans-grey;
    }
  }

  .button {
    margin: 25px 10px 0;
    width: 100%;
    max-width: 240px;
    min-height: 50px;

    > span {
      @include font-rubik-white(18px, 500, 22px, uppercase);
    }
  }
}
</style>
